@if (!editing) {
  <div class="item">
    <div class="container">
      <h4 class=" h5 bold no-margin-bottom">{{column?.name}}</h4>
      <div class="options-container">
        <button title="Edit Column" attr.aria-label="Edit Column: {{column?.name}}">
          <svg-icon icon="icon-pencil" class="small" aria-hidden="true" (click)="toggleEdit($event)"></svg-icon>
        </button>
        <button title="Delete Column" attr.aria-label="Delete Column: {{column?.name}}">
          <svg-icon icon="icon-trash" class="small" aria-hidden="true" (click)="delete($event)"></svg-icon>
        </button>
      </div>
    </div>
    <div class="container">
      <div class="no-margin-bottom">Property: {{column?.objectProperty?.name}}</div>
      <div class="no-margin-bottom">Renderer: {{column?.renderer}}</div>
    </div>
  </div>
} @else {
  <form [formGroup]="form">
    <div class="full-width">
      <label for="nameControl">Column Name:</label>
      <input type="text" id="nameControl" formControlName="name" />
    </div>
    <div class="grid-x">
      @if (properties) {
        <div class="cell shrink"><label class="display-inline-block margin-bottom input-height">Selected Property: {{column?.objectProperty?.name}}</label></div>
      }
      <div class="cell small-12" [class.auto]="properties">
        <property-selector [propertyPath]="column?.objectProperty?.path" [properties]="properties" (selectedProperty)="setSelectedProperty($event)"></property-selector>
      </div>
      <div class="cell small-12">
        <label class="full-width" for="renderer">Renderer Type:</label>
        <select id="renderer" formControlName="renderer">
          <option value="default">Default</option>
          @for (renderer of rendererTypes; track renderer) {
            <option [value]="renderer">{{renderer}}</option>
          }
        </select>
      </div>
      <div class="cell small-12">
        <label class="full-width" for="minWidth">Minimum Width:</label>
        <input type="number" id="minWidth" formControlName="minWidth" />
      </div>
      <div class="cell small-12">
        <label class="full-width" for="formatter">Formatter:</label>
        <select id="formatter" formControlName="formatter">
          @for (formatter of formatterTypes; track formatter) {
            <option [value]="formatter">{{formatter}}</option>
          }
        </select>
      </div>
      <div class="cell small-12">
        <ng-container #formatterSettings></ng-container>
      </div>
      <div class="cell small-4">
        <div class="checkbox">
          <input [id]="column.name + 'filterable'" class="show-for-sr" type="checkbox" formControlName="filterable">
          <label [for]="column.name + 'filterable'" class="inline">
            Filterable
            <span class="checkbox-box" aria-hidden="true" styledCheckbox>
              <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
            </span>
          </label>
        </div>
      </div>
      <div class="cell small-4">
        <div class="checkbox">
          <input [id]="column.name + 'sortable'" class="show-for-sr" type="checkbox" formControlName="sortable">
          <label [for]="column.name + 'sortable'" class="inline">
            Sortable
            <span class="checkbox-box" aria-hidden="true" styledCheckbox>
              <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
            </span>
          </label>
        </div>
      </div>
      <div class="cell small-4">
        <div class="checkbox">
          <input [id]="column.name + 'resizable'" class="show-for-sr" type="checkbox" formControlName="resizable">
          <label [for]="column.name + 'resizable'" class="inline">
            Resizable
            <span class="checkbox-box" aria-hidden="true" styledCheckbox>
              <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
            </span>
          </label>
        </div>
      </div>
      <div class="cell small-12 text-right">
        <button class="button small" attr.aria-label="Save" [disabled]="!form.valid" (click)="toggleEdit($event)">Save</button>
      </div>
    </div>
  </form>
}

